import React from 'react';
import { useModeContext } from '../../../common/contexts/mode-context';
import CompletedFormState from './completed-form-state';
import css from './completed-form-page.module.scss';
import { withCurrentUser } from '../../../common/current-user';
import type { User } from '../../../types/User';

type Props = {
  currentUser: User;
  isAuthenticationRequired: boolean;
  numFiles: number;
};

const CompletedFormPage = (props: Props) => {
  const { isAuthenticationRequired, numFiles, currentUser } = props;
  const { mode } = useModeContext();
  return (
    <div className={css.container}>
      <CompletedFormState
        currentUser={currentUser}
        formType={mode}
        isAuthenticationRequired={isAuthenticationRequired}
        numFiles={numFiles}
      />
    </div>
  );
};

export { CompletedFormPage };
export default withCurrentUser(CompletedFormPage);
